import Service, { service } from '@ember/service';

import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class RecordPresentationService extends Service {
  // Services
  @service intl;

  // Functions
  recordOverline(record) {
    if (!record) {
      return undefined;
    }

    const recordTypeLabel = this.intl.t(`models.${getRecordType(record)}`);
    const modelId = record.id ? ` — ID: ${record.id}` : '';
    const assetTypeSelector = record.assetTypeSelector
      ? ` (${record.assetTypeSelector})`
      : '';

    return `${recordTypeLabel}${assetTypeSelector}${modelId}`;
  }

  recordHeadlineOrNew(record) {
    if (!record) {
      return undefined;
    }

    const displayHeadline = record.displayHeadline;

    if (displayHeadline) {
      return displayHeadline;
    }

    const recordTypeLabel = this.intl.t(`models.${getRecordType(record)}`);

    return this.intl.t('record_detail.add_new', {
      recordTypeLabel: recordTypeLabel,
    });
  }
}
